<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="主播手机号：">
        <el-input v-model="query.anchorPho" placeholder="请输入主播手机号" clearable size="small" />
      </el-form-item>
      <el-form-item label="直播主题：">
        <el-input v-model="query.levelTitle" placeholder="请输入直播主题" clearable size="small" />
      </el-form-item>
      <el-form-item label="直播间ID：">
        <el-input v-model="query.liveId" placeholder="请输入直播间ID" clearable size="small" />
      </el-form-item>
      <el-form-item label="订单状态：">
        <el-select v-model="query.state" placeholder="全部" clearable size="small">
          <el-option label="全部" :value="null"></el-option>
          <el-option label="未支付" :value="0"></el-option>
          <el-option label="已支付" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import liveRewardOrderApi from '@/api/live/liveRewardOrder'
import { filterEmpty } from '@/utils'
export default {
  data() {
    return {
      query: {
        anchorPho: undefined,
        levelTitle: undefined,
        liveId: undefined,
        state: undefined
      }
    }
  },
  created() {
    // 从路由参数获取导出参数
    const { anchorPho, levelTitle, liveId, state } = this.$route.query
    if (anchorPho) this.query.anchorPho = anchorPho
    if (levelTitle) this.query.levelTitle = levelTitle
    if (liveId) this.query.liveId = liveId
    if (state !== undefined && state !== null) this.query.state = state === '0' ? 0 : (state === '1' ? 1 : parseInt(state))
  },
  methods: {
    handleDownload() {
      return this.$common.confirm('是否确认导出')
        .then(() => liveRewardOrderApi.exportCourseOrder(filterEmpty(this.query))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    }
  }
}
</script>

<style>
</style>

